import React from 'react'
import CA_form_img from '../Image/CA_form_img.webp'
import who_join from '../Image/who_join.webp'
import CA_forth_comp from '../Component/CA_forth_comp'
import {Link} from "react-router-dom";

function Campus_form() {
  return (
    <div>
      {/* -----------------------Mobile View------------------------ */}
      <div className="Combo_background_image d-sm-block d-md-none mt-5">
        <div className="container-fluid Combo_background_color pt-5">
          <div className="text-center Combo_Main_text py-5">
            <h1 className="display-2 text-white">Campus Ambassador</h1>
          </div>
        </div>
      </div>

      {/* -------------------Desktop View------------------------- */}
      <div className="Combo_background_image d-none d-md-block mt-5">
        <div className="container-fluid Combo_background_color py-5">
          <div className="text-center pt-5 Combo_Main_text mt-5">
            <h1 className="display-3  py-5 my-5 text-white">
              Campus Ambassador
            </h1>
          </div>
        </div>
      </div>
      <Description />
    </div>
  )
}

function Description() {
  return (
    <div className="">
      {/* -------------------------------Mobile view--------------------------------- */}
      <div className="container d-sm-block d-md-none">
        <div className="text-center mt-3 mobile_About_Discraption_text">
          <h1 className="display-5 text-center">
            What is a Campus Ambassador?
          </h1>
          <p className="">
            A campus ambassador is a student representative who acts as a bridge
            between our organization and your university. As a campus
            ambassador, you will be our voice and promote our brand, events, and
            initiatives on campus. You will have the opportunity to network,
            gain leadership experience, and develop skills that will set you
            apart in your future career.
          </p>
        </div>
      </div>

      {/* -------------------------------Dasktop view--------------------------------- */}
      <div className="container d-none d-md-block pt-5">
        <div className="row">
          <div className="container px-5">
            <div className="text-center About_Discraption_text">
              <h1 className="display-6">What is a Campus Ambassador?</h1>
              <p>
                A campus ambassador is a student representative who acts as a
                bridge between our organization and your university. As a campus
                ambassador, you will be our voice and promote our brand, events,
                and initiatives on campus. You will have the opportunity to
                network, gain leadership experience, and develop skills that
                will set you apart in your future career.
              </p>
            </div>
          </div>
        </div>
      </div>

{/* -----------------------Benefits Comp------------------------------ */}
      <div className="container Campus_form_page">
        <div className="row">
          <div className="col-md-7">
            <div className="BDA_text d-none pt-5 d-md-block mt-5 ">
              <h1 className="dsiplay-6 pb-2">
                Benefits of Becoming a Campus Ambassador
              </h1>
              <span>Benefits:-</span>
              <ul className="pb-3">
                <li className="pt-3">
                  <b>Professional Development:</b> Gain valuable skills in
                  marketing, event planning, public speaking, and leadership.
                </li>
                <li className="pt-2">
                  <b>Networking Opportunities:</b> Connect with industry
                  professionals, fellow ambassadors, and our alumni network.
                </li>
                <li className="pt-2">
                  <b>Exclusive Access:</b> Get early access to our events,
                  resources, and potential internship opportunities.
                </li>
                <li className="pt-2">
                  <b>Recognition and Rewards:</b> Earn certificates, letters of
                  recommendation, and other rewards based on your performance
                  and involvement.
                </li>
                <li className="pt-2">
                  <b>Personal Growth:</b> Enhance your resume, build confidence,
                  and make a positive impact on your campus community.
                </li>
              </ul>
            </div>
            <div className="mobile_BDA_text d-sm-block d-md-none">
              <h1 className="fs-4 text-center pb-2 pt-3">
                Benefits of Becoming a Campus Ambassador
              </h1>
              <span>Benefits:-</span>
              <ul className="pb-3">
                <li className="pt-2">
                  <b>Professional Development:</b> Gain valuable skills in
                  marketing, event planning, public speaking, and leadership.
                </li>
                <li className="pt-2">
                  <b>Networking Opportunities:</b> Connect with industry
                  professionals, fellow ambassadors, and our alumni network.
                </li>
                <li className="pt-2">
                  <b>Exclusive Access:</b> Get early access to our events,
                  resources, and potential internship opportunities.
                </li>
                <li className="pt-2">
                  <b>Recognition and Rewards:</b> Earn certificates, letters of
                  recommendation, and other rewards based on your performance
                  and involvement.
                </li>
                <li className="pt-2">
                  <b>Personal Growth:</b> Enhance your resume, build confidence,
                  and make a positive impact on your campus community.
                </li>
              </ul>
            </div>
          </div>
          <div className="col-md-5">
            <div className="text-center mt-3 d-none d-md-block">
              <img src={CA_form_img}></img>
            </div>
          </div>
        </div>
      </div>

{/* --------------------------Responsibilities Comp---------------------------------- */}
      <div className='container-fluid'>
        <div className='row BDA_text'>
          <div className='col-md-4 py-5 campus_Responsibilities'>
            <div className='container'>
              <div className='pt-3 pb-5'>
                <h1 className='fs-3 text-white'>Responsibilities of a Campus Ambassador</h1>
              </div>
            </div>
          </div>
          <div className='col-md-8'>
            <div>
            <ul className="pb-3">
                <li className="pt-5">
                <b>Brand Promotion:</b> Promote our brand through social media, campus events, and word-of-mouth.
                </li>
                <li className="pt-2">
                <b>Event Coordination:</b> Organize and participate in events, workshops, and promotional activities.
                </li>
                <li className="pt-2">
                <b>Market Research:</b> Gather feedback from students about our products, services, and initiatives.
                </li>
                <li className="pt-2">
                <b>Content Creation:</b> Create engaging content, such as blog posts, videos, and social media updates, to promote our brand.
                </li>
                <li className="pt-2">
                <b>Community Engagement:</b> Build and nurture a community of students interested in our brand and its mission.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

{/* -------------------Who Join Comp----------------------------- */}
      <div className='container'>
        {/* -------------------------------Mobile view--------------------------------- */}
      <div className="container d-sm-block d-md-none">
        <div className="text-center mobile_About_Discraption_text">
          <h1 className="display-5 text-center">
          Who Can Apply?
          </h1>
          <p className="text-center">We are looking for enthusiastic, proactive, and responsible students who are:
          </p>
        </div>

        <div>
        <div className='text-center pt-3'><img className='who_join_img' src={who_join}></img></div>
        <div className='text-center'>
        <p className='text-danger fw-bold pt-3'>Currently enrolled in a university.</p>
        <p className='text-success fw-bold py-1'>Active in campus activities and student organizations.</p>
        <p className='text-warning fw-bold'>Passionate about our brand and mission.</p>
        <p className='text-info fw-bold py-1'>Possess excellent communication and interpersonal skills.</p>
        <p className='fw-bold'>Willing to commit a few hours each week to ambassador duties.</p>
        </div>
        </div>
      </div>

      {/* -------------------------------Dasktop view--------------------------------- */}
      <div className="container d-none d-md-block pt-5">
        <div className="row">
          <div className="container px-5">
            <div className="text-center About_Discraption_text">
              <h1 className="display-6">Who Can Apply?</h1>
              <p>We are looking for enthusiastic, proactive, and responsible students who are:
              </p>
            </div>
          </div>
        </div>
        <div className='row text-center mt-3'>
          <div className='col-md-3'>
            <div>
              <p className='text-danger fw-bold py-5 mt-5 fs-5'>Currently enrolled in a university.</p>
            </div>
            <div><p className='text-success fw-bold py-5 mt-5 fs-5'>Active in campus activities and student organizations.</p></div>
          </div>
          <div className='col-md-6'>
            <div>
              <img className='who_join_img' src={who_join}></img>
            </div>
          </div>
          <div className='col-md-3'>
          <div><p className='text-warning fw-bold py-5 mt-5 fs-5'>Passionate about our brand and mission.</p></div>
          <div><p className='text-info fw-bold py-5 mt-5 fs-5'>Possess excellent communication and interpersonal skills.</p></div>
          </div>
          <div>
            <p className='fw-bold py-3 fs-5'>Willing to commit a few hours each week to ambassador duties.</p>
          </div>
        </div>
      </div>
        
      </div>

{/* -------------------------Apply Comp----------------------------- */}
      <div className=' my-3'>
        <CA_forth_comp/>
      </div>
      <div>
      <div className='counsellor_background py-4 mb-5 mt-4'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-1'></div>
            <div className='col-md-10 text-center'>
            <h1 className='display-6'>Free Certificate</h1>
            <p className='py-2'>Make an appointment with one of our certified counselors to get individualized assistance with your academic and career goals</p>
            <Link to='/Campus-Ambassadar-Certificat'>
            <button className="text-white shadow-sm fs-5 px-5 pt-1 pb-2 Pr_details_button">Click Here</button>
            </Link>
            </div>
            <div className='col-md-1'></div>
          </div>
        </div>
      </div>
    </div>
    </div>
  )
}

export default Campus_form
